import React, { useState } from "react";
import arrowR from "./../assets/arrowR.png";
import arrowL from "./../assets/arrowL.png";

const Step1 = ({ setCurrentStep, answers, setAnswers, currentStep, resetSelection, t }) => {
  const [errors, setErrors] = useState({});

  // Funzione per validare i campi richiesti
  const validateStep = (step) => {
    let newErrors = {};

    if (step === 5) {
      if (!answers.name) newErrors.name = t.nameRequired;;
    } else if (step === 6) {
      if (!answers.mail) {
        newErrors.mail = t.emailRequired;
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(answers.mail)) {
        newErrors.mail = t.emailInvalid;
      }
      if (!answers.tel) newErrors.tel = t.telRequired;
    } else if (step === 7) {
      if (!answers.attivita) newErrors.attivita = t.companyRequired;
      if (!answers.sito) newErrors.sito = t.siteRequired;
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // True se non ci sono errori
  };

  // Funzione per avanzare di step con validazione
  const goToNextStep = (nextStep) => {
    if (validateStep(currentStep)) {
      setCurrentStep(nextStep);
    }
  };

  // Funzione per avanzare premendo Invio
  const handleEnter = (event, nextStep) => {
    if (event.key === "Enter") {
      goToNextStep(nextStep);
    }
  };

  return (
    <>
      {currentStep === 5 && (
        <div className="step-container">
          <h1 className="h1Config">{t.titleStepUserInfo}</h1>
          <p className="subTitle">{t.subtitleStepUserInfo}</p>
          <div className="form-container">
            <input
              type="text"
              placeholder={t.namePlaceholder}
              value={answers.name || ""}
              autoComplete="off" // Disabilita auto-complete
              onChange={(e) => setAnswers((prev) => ({ ...prev, name: e.target.value }))}
              onKeyDown={(e) => handleEnter(e, 6)} // Premendo "Enter" va avanti
            />
            {errors.name && <p className="error-message">{errors.name}</p>}
          </div>
          <div className="navigation-buttons button-container">
            <button onClick={() => setCurrentStep(4)}>
              <img src={arrowL} alt="Freccia left" /> {t.indietro}
            </button>
            <button onClick={() => goToNextStep(6)}>
            {t.avanti} <img src={arrowR} alt="Freccia right" />
            </button>
          </div>
        </div>
      )}

      {currentStep === 6 && (
        <div className="step-container">
          <h1 className="h1Config">{t.titleStepUserInfo}</h1>
          <p className="subTitle">{t.subtitleStepUserInfo}</p>

          <div className="form-container">
            <input
              type="text"
              placeholder={t.emailPlaceholder}
              value={answers.mail || ""}
              autoComplete="off"
              onChange={(e) => setAnswers((prev) => ({ ...prev, mail: e.target.value }))}
              onKeyDown={(e) => handleEnter(e, 7)}
            />
            {errors.mail && <p className="error-message">{errors.mail}</p>}
            <input
              type="text"
              placeholder={t.phonePlaceholder}
              value={answers.tel || ""}
              autoComplete="off"
              onChange={(e) => setAnswers((prev) => ({ ...prev, tel: e.target.value }))}
              onKeyDown={(e) => handleEnter(e, 7)}
            />
            {errors.tel && <p className="error-message">{errors.tel}</p>}
          </div>

          <div className="navigation-buttons button-container">
            <button onClick={() => setCurrentStep(5)}>
              <img src={arrowL} alt="Freccia left" /> {t.indietro}
            </button>
            <button onClick={() => goToNextStep(7)}>
            {t.avanti} <img src={arrowR} alt="Freccia right" />
            </button>
          </div>
        </div>
      )}

      {currentStep === 7 && (
        <div className="step-container">
          <h1 className="h1Config">{t.titleStepUserInfo}</h1>
          <p className="subTitle">{t.subtitleStepUserInfo}</p>

          <div className="form-container">
            <input
              type="text"
              placeholder={t.companyPlaceholder}
              value={answers.attivita || ""}
              autoComplete="off"
              onChange={(e) => setAnswers((prev) => ({ ...prev, attivita: e.target.value }))}
              onKeyDown={(e) => handleEnter(e, 8)}
            />
            {errors.attivita && <p className="error-message">{errors.attivita}</p>}
            <input
              type="text"
              placeholder={t.websitePlaceholder}
              value={answers.sito || ""}
              autoComplete="off"
              onChange={(e) => setAnswers((prev) => ({ ...prev, sito: e.target.value }))}
              onKeyDown={(e) => handleEnter(e, 8)}
            />
            {errors.sito && <p className="error-message">{errors.sito}</p>}
          </div>

          <div className="navigation-buttons button-container">
            <button onClick={() => setCurrentStep(6)}>
              <img src={arrowL} alt="Freccia left" /> {t.indietro}
            </button>
            <button onClick={() => goToNextStep(8)}>
            {t.avanti} <img src={arrowR} alt="Freccia right" />
            </button>
          </div>
        </div>
      )}

      {currentStep === 8 && (
        <div className="step-container">
          <h1 className="h1Config">{t.titleStepThanks}</h1>
          <p className="subTitle">{t.subtitleStepThanks}</p>
          <div className="navigation-buttons button-container">
          <button onClick={resetSelection}>{t.restart}</button>
            {/* <button onClick={() => setCurrentStep(7)}>
              <img src={arrowL} alt="Freccia left" /> Indietro
            </button> */}
          </div>
        </div>
      )}
    </>
  );
};

export default Step1;
